import { createSlice } from '@reduxjs/toolkit';
import { incidentsApi } from '../functions/IncidentsApi';
import { toast } from 'react-toastify';
import { firehouseApi } from '../functions/firehouseApi';

const initialState = {
  employeesList: [],
  rolesList: [],
  loadingEmployeesList: false,
  permissions: {},
  loadingPermissions: false,
};

export const nerisSettingsReducer = createSlice({
  name: 'nerisSettingsAuthoritiesReducer',
  initialState,
  reducers: {
    setEmployeesList: (state, action) => {
      state.employeesList = action.payload;
    },
    setEmployeeRole: (state, action) => {
      state.employeesList = state.employeesList.map((item) => {
        if (action.payload.employee === item.id)
          return { ...item, role: action.payload.role };
        else return item;
      });
    },
    setRolesList: (state, action) => {
      state.rolesList = action.payload;
    },
    setLoadingEmployeesList: (state, action) => {
      state.loadingEmployeesList = action.payload;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    setLoadingPermissions: (state, action) => {
      state.loadingPermissions = action.payload;
    },
  },
});

export const {
  setEmployeesList,
  setLoadingEmployeesList,
  setRolesList,
  setEmployeeRole,
  setLoadingPermissions,
  setPermissions,
} = nerisSettingsReducer.actions;

export default nerisSettingsReducer.reducer;

export const getPermissionRole = () => async (dispatch) => {
  try {
    dispatch(setLoadingEmployeesList(true));
    const response = await incidentsApi.getPermissionRole();
    if (response.status === 200) {
      dispatch(setEmployeesList(response.data.employees));
      dispatch(setRolesList(response.data.roles));
    } else throw new Error(response);
  } catch (err) {
    toast.error('Failed to saving settings');
    console.log(err);
  } finally {
    dispatch(setLoadingEmployeesList(false));
  }
};

export const setPermissionRole = (data) => async (dispatch) => {
  try {
    const response = await incidentsApi.setPermissionRole(data);

    if (response.status === 200) {
      dispatch(setEmployeeRole(data));
      toast.success('Role successfully changed');
    } else throw new Error(response);
  } catch (err) {
    toast.error('Failed to saving role');
    console.log(err);
  }
};

export const getPermissions = (params) => async (dispatch) => {
  try {
    dispatch(setLoadingPermissions(true));

    if (!params.employee) throw new Error('The emp code field is required.');

    const [responseNeris, response] = await Promise.all([
      firehouseApi.getNerisPermissions({
        EmpCode: params.employee,
      }),
      incidentsApi.getPermissions(params),
    ]);

    if (response.status === 200) {
      const permissions = { ...response.data };
      if (responseNeris.message === 'Adaptive authority allowed!') {
        permissions.can_assign_officer = true;
      }
      dispatch(setPermissions(permissions));
    } else
      throw new Error(
        response.response?.data?.message || response.response?.data?.error
      );

    if (
      responseNeris.message !== 'Adaptive authority allowed!' &&
      responseNeris.status !== 400
    ) {
      throw new Error(responseNeris.data?.message);
    }
  } catch (err) {
    toast.error(err.message || 'Failed to get permissions');
  } finally {
    dispatch(setLoadingPermissions(false));
  }
};
